import React, { FunctionComponent, MouseEvent } from 'react';

import { Row, Col, Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { ReviewActionsMenuContainer } from 'reviews2/feed/review-yeti/actions-container/ActionsMenuContainer';
import { ReviewAttributions } from 'reviews2/feed/review-yeti/attributions/ReviewAttributions';
import { ReviewDate } from 'reviews2/feed/review-yeti/date/ReviewDate';
import { ReviewHistoryLink } from 'reviews2/feed/review-yeti/history/review-history-link/ReviewHistoryLink';
import { ReviewLabels } from 'reviews2/feed/review-yeti/labels/ReviewLabels';
import { ReviewLocation } from 'reviews2/feed/review-yeti/location/ReviewLocation';
import { ReviewPoster } from 'reviews2/feed/review-yeti/poster/ReviewPoster';
import { ReviewRepliesContainer } from 'reviews2/feed/review-yeti/replies-container/ReviewRepliesContainer';
import { useReview } from 'reviews2/feed/review-yeti/Review.store';
import { ContextProps } from 'reviews2/feed/review-yeti/Review.types';
import { ReviewSource } from 'reviews2/feed/review-yeti/source/ReviewSource';
import { TemplateFieldCategory } from 'reviews2/feed/review-yeti/template/field/TemplateFieldCategory';
import { TemplateFieldComment } from 'reviews2/feed/review-yeti/template/field/TemplateFieldComment';
import { TemplateFieldProperty } from 'reviews2/feed/review-yeti/template/field/TemplateFieldProperty';
import { TemplateFieldRating } from 'reviews2/feed/review-yeti/template/field/TemplateFieldRating';
import { TemplateFieldSubRating } from 'reviews2/feed/review-yeti/template/field/TemplateFieldSubRating';
import { TemplateFieldTitle } from 'reviews2/feed/review-yeti/template/field/TemplateFieldTitle';

import 'reviews2/feed/review-yeti/card/ReviewCard.scss';

export const ReviewCard: FunctionComponent<ContextProps> = ({ context }) => {
    const { t } = useTranslation('reviews2');
    const [{ review }] = useReview();
    const { reviewClick } = context.handlers!;

    return (
        <Card
            className="r4e-review-card"
            onClick={(event: MouseEvent<HTMLElement>): void => reviewClick?.(review!, event)}
        >
            <Card.Body>
                {review ? (
                    <Row>
                        <Col md={3} style={{ wordBreak: 'break-all' }}>
                            <div className="d-flex d-md-none justify-content-between align-items-start">
                                <div className="me-2">
                                    {' '}
                                    <ReviewSource context={context} />
                                </div>

                                <div>
                                    {context.profile && context.config ? (
                                        <ReviewActionsMenuContainer context={context} />
                                    ) : null}
                                </div>
                            </div>

                            <div className="d-none d-md-block">
                                <ReviewSource context={context} />
                            </div>

                            <ReviewLocation context={context} />
                            <ReviewPoster context={context} />
                            <ReviewDate context={context} />
                            <ReviewLabels context={context} />
                            <ReviewHistoryLink context={context} />
                        </Col>
                        <Col md={9}>
                            <Row>
                                <Col>
                                    <TemplateFieldRating context={context} />
                                    <TemplateFieldTitle context={context} />
                                    <TemplateFieldComment context={context} />
                                    <TemplateFieldSubRating context={context} />
                                    <TemplateFieldProperty context={context} />
                                    <TemplateFieldCategory context={context} />
                                    <ReviewAttributions context={context} />
                                </Col>
                                <Col xs={1} className="d-none d-md-block">
                                    {context.profile && context.config ? (
                                        <ReviewActionsMenuContainer context={context} />
                                    ) : null}
                                </Col>
                            </Row>
                            <ReviewRepliesContainer context={context} />
                            {/* <ReviewRedirect context={context} /> */}
                        </Col>
                    </Row>
                ) : (
                    <Row>
                        <Col xs={12}>
                            <div className="text-center text-muted">{t('REVIEW_NO_DATA')}</div>
                        </Col>
                    </Row>
                )}
            </Card.Body>
        </Card>
    );
};
